import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { useGetMonitoringHealthComponent } from 'src/features/monitoring/api/useGetMonitoringHealthComponent';
import HealthIssuesHoverBadge, { HAS_ISSUES_STATUSES } from 'src/features/monitoring/components/HealthIssuesHoverBadge';
import { MonitoringHealthComponent } from 'src/features/monitoring/types';
import { ComponentBadgeOptions } from 'src/features/systems/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';
import {
    GeneralBlock,
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSubtitle,
    GeneralBlockTitle,
} from 'src/registry/components/blocks/GeneralBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';

export default function SingleMonitoringDevice({ device }: { device: MonitoringHealthComponent }) {
    const { parkingId } = useParking();
    const [isOpen, setIsOpen] = React.useState(false);

    const showCount = HAS_ISSUES_STATUSES.includes(device.status) && device.active_issue_count > 0;

    const { data: detail, isLoading } = useGetMonitoringHealthComponent({
        parkingId,
        componentId: device.id,
        config: { enabled: showCount && isOpen },
    });

    const icon = ComponentBadgeOptions[device.component]?.icon as IconProp | undefined;

    return (
        <GeneralBlock className="w-full flex-row items-center justify-between">
            <GeneralBlockHeader>
                {icon && <SquareIcon icon={icon} className="shrink-0" />}
                <GeneralBlockHead>
                    <GeneralBlockTitle>{device.name}</GeneralBlockTitle>
                    <GeneralBlockSubtitle>{device.code}</GeneralBlockSubtitle>
                </GeneralBlockHead>
            </GeneralBlockHeader>
            <HealthIssuesHoverBadge
                status={device.status}
                activeIssueCount={device.active_issue_count}
                isOpen={isOpen}
                onOpenChange={setIsOpen}
                isLoadingIssues={isLoading}
                issues={detail?.active_issues}
            />
        </GeneralBlock>
    );
}
